// extracted by mini-css-extract-plugin
export default {"button":"ScrollToTop_button__vx1QN"};